function DateTimeList(params) {
  this.dates = params.dates;
  this.showTime = params.showTime || false;
}

module.exports = DateTimeList;
